import { setdefaultGroupId, getdefaultGroupId } from '../../localStorage/localStorage'
const dashboard = {
    state: {
        NavShow: false,
        Logo: false,
        defaultGroupId: getdefaultGroupId() ? getdefaultGroupId() : ''
    },
    mutations: {
        //显示隐藏nav
        SHOW_NAV(state) {
            state.NavShow = !state.NavShow
        },
        //获取当前客户(用户)LOGO
        STORAGE_LOGO(state, ImgUrl) {
            state.Logo = ImgUrl
        },
        // 清除当前客户(用户)信息
        CLEAR_USER_INFO(state) {
            state.NavShow = false
            state.Logo = false
            state.defaultGroupId = ''
        },
        //获取当前客户(用户)默认分组
        GETDEFAULTGROUPID(state, defaultGroupId) {
            state.defaultGroupId = defaultGroupId
                //存储默认分组id到localStorage
            setdefaultGroupId(defaultGroupId)
        }
    },
    actions: {
        //显示隐藏nav
        ShowNav({ commit }) {
            commit('SHOW_NAV')
        },
        //获取当前客户(用户)LOGO
        GetLogo({ commit }, ImgUrl) {
            commit('STORAGE_LOGO', ImgUrl)
        },
        //获取当前客户(用户)默认分组
        GetDefaultGroupId({ commit }, defaultGroupId) {
            commit('GETDEFAULTGROUPID', defaultGroupId)
        },
        // 清除当前客户(用户)默认分组
        ClearDefault({ commit }) {
            commit('CLEAR_USER_INFO')
        },
    }
}
export default dashboard